import { render, staticRenderFns } from "./msNumber.vue?vue&type=template&id=2fa54bbe&scoped=true"
import script from "./msNumber.vue?vue&type=script&lang=js"
export * from "./msNumber.vue?vue&type=script&lang=js"
import style0 from "./msNumber.vue?vue&type=style&index=0&id=2fa54bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa54bbe",
  null
  
)

export default component.exports